import React from 'react';
import { Card } from 'react-bootstrap';
// import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import './Products.css';

import { tdmOcaDbData } from "../assets/ProductsData";
import { tdmTocaDbData } from "../assets/ProductsData";
import { tdmOcrDbData } from "../assets/ProductsData";

import tdmOcaDbondImg from '../images/ProductImg/TdmOcaDBond.jpg';
import tdmTocaDbondImg from '../images/ProductImg/TdmTocaDBond.jpg';
import tdmOcrDbondImg from '../images/ProductImg/TdmOcrDBond.jpg';

function ProductTouchLcm() {
  // console.log("get into ProductTouchLcm()");
  return (
    <div className='products-page'>
      <header className='mt-5'>
        <div className='container h-100 d-flex align-items-center justify-content-center'>
          <h1 className='text-light'>Product / Touch Display Module</h1>
        </div>
      </header>

      <section id='tdmocadbond' className='block product-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>Product Touch / P+G PCAP</h2>
        <Container fluid>
          <Row>
            <Col lg={7} className='d-flex flex-column justify-content-around'>
              <Row> {
                <Col lg={12}> {
                  tdmOcaDbData.map((tdm) => {
                    return (
                      <Row key={tdm.id}>
                        <Container className='holder' >
                          <Card className='bg-primary-subtle border-1 p-0 m-0'>
                            <Card.Title className='text-center fs-3 text-primary'> {tdm.title} </Card.Title>
                            <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                          </Card>
                        </Container>
                      </Row>
                    )
                  })
                } </Col>
              } </Row>
            </Col>
            <Col lg={5} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={tdmOcaDbondImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section >

      <section id='tdmtocadbond' className='block product-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Product Touch / G+G PCAP</h2>
        <Container fluid>
          <Row>
            <Col lg={5} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={tdmTocaDbondImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={7} className='d-flex flex-column justify-content-around'>
              <Row> {
                <Col lg={12}> {
                  tdmTocaDbData.map((tdm) => {
                    return (
                      <Row key={tdm.id}>
                        <Container className='holder' >
                          <Card className='bg-success-subtle border-1 p-0 m-0'>
                            <Card.Title className='text-center fs-3 text-success'> {tdm.title} </Card.Title>
                            <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                          </Card>
                        </Container>
                      </Row>
                    )
                  })
                } </Col>
              } </Row>
            </Col>
          </Row>
        </Container>
      </section >

      <section id='tdmocrdbond' className='block product-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>Product Touch / P+G PCAP</h2>
        <Container fluid>
          <Row>
            <Col lg={7} className='d-flex flex-column justify-content-around'>
              <Row> {
                <Col lg={12}> {
                  // <Col sm={12} className='d-flex flex-column justify-content-around'> {
                  tdmOcrDbData.map((tdm) => {
                    return (
                      <Row key={tdm.id}>
                        <Container className='holder' >
                          <Card className='bg-primary-subtle border-1 p-0 m-0'>
                            <Card.Title className='text-center fs-3 text-primary'> {tdm.title} </Card.Title>
                            <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                          </Card>
                        </Container>
                      </Row>
                    )
                  })
                } </Col>
              } </Row>
            </Col>
            <Col lg={5} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={tdmOcrDbondImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section >
    </div>
  )
}

export default ProductTouchLcm;